import styled from '@emotion/styled';

const PhotoItemWrap = styled('div')<PhotoItemWrapperProps>`
  margin: 0 auto;
  padding: 15px;
  width: 100%;
  height: 100%;
  max-height: 510px;

  max-width: ${(props: PhotoItemWrapperProps): string =>
    props.landscape ? '540px' : '370px'};

  @media (min-width: 768px) {
    .verticalLayout.homePage & {
      margin: 0 auto 0 0;
      padding: 15px 0;
    }
  }
`;

interface PhotoItemWrapperProps {
  landscape: boolean;
  children: React.ReactNode;
  className?: string | undefined;
  dataTestId?: string;
}

const PhotoItemWrapper = ({
  landscape,
  children,
  className,
  dataTestId = 'PhotoItemWrapper',
}: PhotoItemWrapperProps) => {
  return (
    <PhotoItemWrap
      landscape={landscape}
      className={className}
      data-testid={dataTestId}
    >
      {children}
    </PhotoItemWrap>
  );
};

export default PhotoItemWrapper;
